var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"container"},[_c('van-button',{attrs:{"type":"info"},on:{"click":_vm.selectFile}},[_vm._v("选择文件")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }